import React, {Component} from 'react';
import {Modal, ModalOverlay, ModalContent, ModalBody, ModalHeader, ModalFooter, ModalCloseButton, Box,  Button} from "@chakra-ui/react";
import { JsonViewer } from '@textea/json-viewer'
import _ from "lodash";



function toFixed(num, fixed) {
    var re = new RegExp("^-?\\d+(?:.\\d{0," + (fixed || -1) + "})?");
    return num.toString().match(re)[0];
  }
  
  let omitByDeep = (obj, shouldOmit, convertBool, convertFloat) => {
    obj = _.clone(obj);
    _.forEach(obj, (value, key) => {
      if (shouldOmit(value, key)) {
        delete obj[key];
      }
      if (convertBool) {
        if (_.isBoolean(value)) {
          obj[key] = value ? "YES" : "NO";
        }
      }
      if (convertFloat) {
        if (Number.isFinite(value)) {
          if (!Number.isInteger(value)) {
            // must be a float?
            obj[key] = toFixed(value, 2);
          }
        }
      }
      if (_.isPlainObject(value)) {
        obj[key] = omitByDeep(value, shouldOmit, convertBool, convertFloat);
      }
    });
    return obj;
  };

export default class ScorePreviewModal extends Component 
{

    constructor(props)
    {
        super(props);
        this.state = {

        }

    }


    render()
    {

        return (
            <Modal isOpen={this.props?.show} onClose={() => this.props.close()}>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Scoring Preview</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                <Box rounded="20px" overflow="hidden" bg={ this.state.colorMode === "dark" ? "gray.700": "gray.200"} mt={10}>
                    <JsonViewer
                        value={this.props.score}
                    />
                </Box>
                </ModalBody>
                <ModalFooter>
                    <Button colorScheme='blue' mr={3} onClick={() => this.props.close()}>Close</Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
 
        )
    }
}


